import styled from "styled-components";
import { colors } from "../../consts";

import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";

export const NoteStyled = styled(WrapperContainer)`
  background: ${colors.ISABELLINE};
  border-radius: 8px;
  padding: 12px;
  width: 100%;

  ${Paragraph2} {
    font-size: 14px;
    line-height: 22px;
  }
`;
